var map = {
	"./Mini-intro-videoIMG.jpg": "PFB5",
	"./andy-g-jones-head@2x.png": "hoF+",
	"./fx2-guitar-match.jpg": "7Dkl",
	"./fx2-new-era.jpg": "MUWE",
	"./reece-scruggs-head@2x.png": "gCnJ",
	"./video-1.jpg": "OspG",
	"./video-10.jpg": "x0Kj",
	"./video-11.jpg": "Jyxq",
	"./video-2.jpg": "bcpX",
	"./video-3.jpg": "AZp+",
	"./video-4.jpg": "OrwX",
	"./video-5.jpg": "RUeT",
	"./video-6.jpg": "pf2r",
	"./video-7.jpg": "jiJr",
	"./video-8.jpg": "Jtqg",
	"./video-9.jpg": "QX16"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "X9qF";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video ^\.\/.*$
// module id = X9qF
// module chunks = 13